import React, { useState, useEffect } from 'react';
import { CinchDialog, Button } from '@cinch/ui';
import { toasterService } from 'components/toaster/toaster-service';
export const TagModal = props => {
  const {
    objectTarget,
    viewName,
    getViewTags,
    patchView
  } = props;
  const [tagValue, updateTagValue] = useState('');
  const [companyId, updateCompanyId] = useState();
  const [companyTags, updateCompanyTags] = useState([]);
  const [tags, updateTags] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (objectTarget) {
      updateTags([...(objectTarget.tags || [])].map(t => t.toUpperCase()));
      if (companyId !== objectTarget.company) {
        updateCompanyId(objectTarget.company);
      }
    }
  }, [objectTarget]);
  useEffect(() => {
    if (companyId) {
      getViewTags(companyId).then(({
        data
      }) => updateCompanyTags(data.results.map(t => t.toUpperCase())));
    }
  }, [companyId]);
  const toggleTag = tag => {
    const index = tags.indexOf(tag);
    if (index > -1) {
      updateTags([...tags.slice(0, index), ...tags.slice(index + 1)]);
    } else {
      updateTags([...tags, tag]);
    }
  };
  const addNewTag = newTag => {
    newTag = newTag.toUpperCase();
    updateTagValue('');
    if (!companyTags.includes(newTag)) {
      updateCompanyTags([...companyTags, newTag]);
    }
    if (!tags.includes(newTag)) {
      updateTags([...tags, newTag]);
    }
  };
  const onSubmit = () => {
    setSaving(true);
    return patchView(objectTarget.id, {
      tags
    }).then(({
      data
    }) => {
      toasterService.success(`Successfully updated ${viewName} tags.`);
      if (props.onSuccess) {
        props.onSuccess(data);
      }
      props.onClose();
    }).catch(e => {
      toasterService.error('An unknown error occurred trying to save tags. Please try again');
    }).finally(() => setSaving(false));
  };
  return <CinchDialog title={`Edit ${viewName} Tags`} onClose={props.onClose} onSubmit={onSubmit} submitText="Submit" actionSize="large" isSubmitting={saving} open={!!objectTarget} customWidth="480px" customHeight="auto" bodyData={<>
      <p>Edit Tags for {objectTarget && objectTarget.name}</p>
      <div className="form-group mb-sm">
        <input placeholder="+ New Tag" className="form-control" style={{
        display: 'inline',
        width: '80%'
      }} type="text" value={tagValue} name="tagValue" maxLength="20" onChange={e => updateTagValue(e.target.value)} />
        <Button disabled={tagValue === ''} actionType="primary" style={{
        marginLeft: '1rem',
        padding: '8px 14px',
        fontSize: '16px'
      }} onClick={() => addNewTag(tagValue)}>
          Add
        </Button>
      </div>
      <div className="form-group mb-sm">
        <ul className="select-list ml-2">
          {companyTags.map((tag, i) => {
          return <li key={i}>
                <div className="checkbox-label">
                  <label className="form-check-label">
                    <input className="form-check-input" style={{
                  position: 'relative',
                  top: '1px',
                  transform: 'scale(1.25)'
                }} type="checkbox" onChange={() => toggleTag(tag)} checked={tags.includes(tag)} />
                    {tag}
                  </label>
                </div>
              </li>;
        })}
        </ul>
      </div>
      </>} />;
};